import { basicAdminRoutes } from '../../admin/models/basic-admin-routes';
import { Routes } from '@angular/router';
import { moduleConfig } from './module-config';
import { blogRoutes } from 'src/app/blog/models/blog-routes';

export const routes: Routes = [
    {
        path: '',
        loadComponent: () => import('src/app/front/views/layout/layout.component').then(module => module.LayoutComponent),
        children: [
            ...(moduleConfig.isProductEnabled ? [
                {
                    path: $localize`:@@pathOffer:oferta`,
                    loadComponent: () => import('src/app/rokezzz/product/front/views/offer/offer.component').then(module => module.RokezzzOfferComponent),
                    data: {
                        path: 'offer'
                    },
                    children: [
                        {
                            path: '',
                            loadComponent: () => import('src/app/rokezzz/product/front/views/offer/categories/categories.component').then(m => m.RokezzzCategoriesViewComponent),
                            data: {
                                path: 'offer'
                            }
                        },
                        {
                            path: '' + ':url',
                            loadComponent: () => import('src/app/rokezzz/product/front/views/offer/category-products/category-products.component').then(m => m.RokezzzCategoryProductsViewComponent),
                            data: {
                                path: 'offer',
                                productPath: 'offer.product'
                            }
                        },
                        {
                            path: $localize`:@@pathProduct:produkt` + '/:url',
                            loadComponent: () => import('src/app/rokezzz/product/front/views/offer/simple/simple.component').then(m => m.RokezzzProductSimpleViewComponent),
                            data: {
                                path: 'offer.product',
                                productPath: 'offer.product',
                                offerPath: 'offer'
                            }
                        },
                    ]
                },
            ] : []),
            ...(moduleConfig.isDeleteUserOptionEnabled ? [{
                path: $localize`:@@pathConfirmAccountDeletion:potwierdz-usuniecie-konta`,
                loadComponent: () => import('src/app/rokezzz/user/views/confirm-account-delete/confirm-account-delete.component').then(module => module.RokezzzConfirmAccountDeleteViewComponent),
                data: {
                    path: 'confirmAccountDeletion',
                }
            }] : []),
            ...(moduleConfig.isBlogEnabled ? [...blogRoutes] : []),
        ],
    },
    ...(moduleConfig.isAdminEnabled ? [...basicAdminRoutes] : []),
    {
        path: '**',
        redirectTo: ''
    },
];
